// Actions
export const NAVIGATION_404 = 'NAVIGATION_404';

// Reducer
interface NavigationAction {
  type: string;
}

export interface NavigationReducerState {
  notFound: boolean;
}

const initialState: NavigationReducerState = {
  notFound: false,
};

export const navigationReducer = (
  state: NavigationReducerState = initialState,
  action: NavigationAction,
): NavigationReducerState => {
  switch (action.type) {
    case NAVIGATION_404:
      return {
        notFound: true,
      };
    default:
      return state;
  }
};

// Action Creators
export const navigationNotFound = () => {
  return (dispatch: Function) => {
    dispatch({ type: NAVIGATION_404 });
  };
};
